import React from 'react'
import { observer } from 'mobx-react-lite'

import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'

import { ConnectDrawer, useAccountStore, useGlobalCopyStore } from '../../../common'
import { AccountType } from '../../../core'

import Accounts from '../shared/Accounts'
import TotalCard from '../shared/TotalCard'

import EstimatedContributionCalculator from './EstimatedContributionCalculator'

const MaintainingEmergencySavingsContent = () => {
  const { savingsAccounts } = useAccountStore()
  const { finstrong: copy } = useGlobalCopyStore()

  const [isConnectDrawerOpen, setIsConnectDrawerOpen] = React.useState(false)

  const total = React.useMemo(
    () => savingsAccounts.reduce((acc, account) => acc + (account.balance ?? 0), 0),
    [savingsAccounts],
  )

  return (
    <Stack sx={{ gap: 24 }}>
      <Card sx={{ bgcolor: 'background.paper', p: 16 }}>
        <Stack sx={{ gap: 16 }}>
          <TotalCard balance={total} title={copy.maintain_emergency_savings_your_savings} />
          {savingsAccounts.length ? (
            <Accounts
              loadAccounts={[AccountType.SAVINGS]}
              loadMoreLabel={copy.connect_more_accounts_button}
            />
          ) : (
            <Button onClick={() => setIsConnectDrawerOpen(true)} variant="contained">
              {copy.connect_more_accounts_button}
            </Button>
          )}
        </Stack>
      </Card>
      <EstimatedContributionCalculator total={total} />
      <ConnectDrawer
        onClose={() => setIsConnectDrawerOpen(false)}
        showConnectWidget={isConnectDrawerOpen}
        title={copy.connect_more_accounts_button}
      />
    </Stack>
  )
}

export default observer(MaintainingEmergencySavingsContent)
